import React, {Component} from "react";
import './index.less'
export default class PortalContentCharacter extends Component{
    constructor(props) {
        super(props)
        this.state = {
            title:"平台特色",
            contents:[
                {
                    key:"contents1",
                    title:"零代码创建",
                    icon:'iconlingdaimachuangjianjiqiren',
                    desc1:"一名业务人员即可依托平台完成专属机器人的创建、知识配置、发布上线的全流程。整个过程无需开发资源的投入，零代码拥有专属机器人。",
                },
                {
                    key:"contents2",
                    title:"多渠道接入",
                    icon:'iconduoqudaojicheng',
                    desc1:"无开发能力者，可选择平台提供的现成组件，支持网站、微信公众号、桌面客户端、手机APP的分钟级接入。",
                    desc2:"有开发能力者，可选择平台提供的API，定制个性化的界面展示、特色功能等。",
                },
                {
                    key:"contents3",
                    title:"多机器人创建",
                    icon:'iconzhinengkefu-icon',
                    desc1:"平台支持多个机器人的创建。每个机器人拥有自己的知识库、任务问答及数据分析等。当您的业务涉及多个场景时，可以部署多个不同的机器人来进行服务。",
                }
            ]
        }
    }
    render() {
        let { title,contents } = this.state
        return (
            <div className={'portal-content-character'}>
                <div className={'portal-content-character-content w1200'} id={'portalCharacter'}>
                    <h2>{title}</h2>
                    <ul>
                        {contents.map(ele => {
                            return (
                                <li key={ele.key}>
                                    <span className={`icon iconfont ${ele.icon}`}></span>
                                    <h3>{ele.title}</h3>
                                    <p>{ele.desc1}</p>
                                    {
                                        ele.desc2 ? <p>{ele.desc2}</p> : null
                                    }
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        )
    }
}